import React, { useContext } from 'react'
import CompactWorkItem from '@Components/WorkItemV2/CompactWorkItem'
import WorkItemData from '@Components/WorkItemV2/work-item-data'
import ShareDisplay from '@Components/WorkItemV2/ShareDisplay'
import { CardWithHeader } from '@Components/Tables/CardResults/card-with-header'
import Navigation from '@App/navigation'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import SongwriterCompactWorkItemHeader from '@Components/WorkItemV2/Catalog/SongwriterCatalogCompactWorkItem/SongwriterCompactWorkItemHeader'
import RequestUpdateSharesButton from '@Components/WorkItemV2/Catalog/SongwriterCatalogExtendedWorkItem/RequestUpdateSharesButton'

const SongwriterCatalogCompactWorkItem: CardWithHeader<WorkItemData> = ({ work, handleOnClick }: WorkItemData) => {
    const { songwriterStore } = useContext<RootStore>(StoresContext)

    const catalogPath = Navigation.songwriter.catalog.viewWork(songwriterStore.currentSongwriterId, work.id ?? '')
    const requestUpdateSharesPath = Navigation.songwriter.catalog.requestUpdateShares(
        songwriterStore.currentSongwriterId,
        work.id ?? ''
    )
    return (
        <CompactWorkItem work={work} catalogPath={catalogPath} handleOnClick={handleOnClick}>
            <div className="container shares-group songwriter-catalog-share-actions">
                <ShareDisplay share={work.totalKnownShares} title="Total Known Shares" highlight />
                <RequestUpdateSharesButton to={requestUpdateSharesPath} />
            </div>
        </CompactWorkItem>
    )
}

SongwriterCatalogCompactWorkItem.headerType = SongwriterCompactWorkItemHeader

export default SongwriterCatalogCompactWorkItem
